const JOURNAL_ROOT = '/journal'

/**
 * Путь журнала: `/journal`, `/journal/{tag}` или `/journal/{tag}/{article}`.
 * Старые урлы `/journal--{tag}--{article}` обслуживает только pages/[general].tsx,
 * новые ссылки на них не строим.
 */
export const getJournalPath = (
  tagSlug?: string | null,
  journalSlug?: string | null
) => {
  if (journalSlug) return `${JOURNAL_ROOT}/${tagSlug}/${journalSlug}`
  if (tagSlug) return `${JOURNAL_ROOT}/${tagSlug}`
  return JOURNAL_ROOT
}
